/**
 * Rol kartı / liste — yalnızca görünen ad (displayName).
 * Teknik `name` (slug) kullanıcıya gösterilmez.
 */
export function getRoleDisplayLabel(role) {
  if (!role) return '—';

  const label =
    (typeof role.displayName === 'string' && role.displayName.trim()) ||
    (typeof role.display_name === 'string' && role.display_name.trim()) ||
    (typeof role.DisplayName === 'string' && role.DisplayName.trim()) ||
    '';

  return label || '—';
}

function normalizePermissions(raw) {
  if (Array.isArray(raw)) {
    return raw.map((p) => String(p).trim()).filter(Boolean);
  }
  if (raw === null || raw === undefined || raw === '') return [];
  return String(raw)
    .split(',')
    .map((p) => p.trim())
    .filter(Boolean);
}

/**
 * API yanıtından rol nesnesini normalize eder.
 * Backend camelCase ve snake_case alanları karışık dönebilir.
 */
export function mapRoleFromAPI(role) {
  if (!role || typeof role !== 'object') return role;

  const name = role.name ?? role.Name ?? '';
  const displayNameRaw =
    role.displayName ?? role.display_name ?? role.DisplayName ?? '';
  const displayName =
    typeof displayNameRaw === 'string' ? displayNameRaw.trim() : String(displayNameRaw || '').trim();

  return {
    id: role.id ?? role.Id,
    name,
    displayName,
    description: role.description ?? role.Description ?? '',
    permissions: normalizePermissions(role.permissions ?? role.Permissions),
    isSystem: role.isSystem ?? role.IsSystem ?? role.is_system ?? false,
    createdAt: role.createdAt ?? role.CreatedAt ?? role.created_at ?? null,
    updatedAt: role.updatedAt ?? role.UpdatedAt ?? role.updated_at ?? null,
    createdBy: role.createdBy ?? role.CreatedBy ?? role.created_by ?? null,
    updatedBy: role.updatedBy ?? role.UpdatedBy ?? role.updated_by ?? null,
    userCount: role.userCount ?? role.UserCount ?? role.user_count,
  };
}
